// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_oT2bd","dangerous":"view-default_dangerous_97-aF"};